
import { Component, Prop, Vue } from "vue-property-decorator";
import { ColorId } from "../model/misc";
import { PaletteData } from "../service/visual.type";
import { FillerEditorModel } from "./FillerEditorModel";
import {
  fillerPickerDestroyed,
  fillerPickerSelected,
} from "../store/EditorStore";
import { IFillerPicker } from "../store/IFillerPicker";

const palette: PaletteData = {
  or: "ff0",
  argent: "fff",
  sable: "000",
  azur: "00f",
  sinople: "0f0",
  gueules: "f00",
  pourpre: "f0f",
};
const defaultColor = "888";

interface IconColors {
  color1: string;
  color2: string;
}

@Component
export default class FillerPicker extends Vue implements IFillerPicker {
  @Prop() value!: FillerEditorModel;

  selected = false;

  get colors(): IconColors {
    switch (this.value.type) {
      case "plein":
        return this.getColorFillers(this.value.color1, this.value.color1);
      case "seme":
      case "pattern":
      case "strip":
        return this.getColorFillers(this.value.color1, this.value.color2);
      case "none":
      default:
        return this.formatFiller("666", "aaa");
    }
  }

  private formatFiller(color1: string, color2: string): IconColors {
    return { color1: `fill: #${color1}`, color2: `fill: #${color2}` };
  }

  private getColorFillers(colorId1: ColorId, colorId2: ColorId): IconColors {
    const color1 = this.palette(colorId1);
    const color2 = this.palette(colorId2);
    return this.formatFiller(color1, color2);
  }

  private palette(colorId: ColorId): string {
    const color = palette[colorId];
    if (color) {
      return color;
    } else {
      return defaultColor;
    }
  }

  click(): void {
    fillerPickerSelected(this);
    this.selected = true;
  }

  public getFillerModel(): FillerEditorModel {
    return this.value;
  }

  public fillerModelUnselect(): void {
    this.selected = false;
  }

  destroyed(): void {
    fillerPickerDestroyed(this);
  }
}
